import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "wrapper-sample-book" }
const _hoisted_2 = { class: "above-info" }
const _hoisted_3 = { class: "wrapper-buttons" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "wrapper-samples" }
const _hoisted_6 = { class: "wrapper-image" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "wrapper-buttons" }
const _hoisted_9 = { class: "wrapper-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalCreateEditSample = _resolveComponent("ModalCreateEditSample")!
  const _component_ModalCreateEditInventoryImage = _resolveComponent("ModalCreateEditInventoryImage")!
  const _component_ModalConfirmation = _resolveComponent("ModalConfirmation")!
  const _component_StandardButton = _resolveComponent("StandardButton")!
  const _component_EditButton = _resolveComponent("EditButton")!
  const _component_DeleteButton = _resolveComponent("DeleteButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_ModalCreateEditSample, {
      originalReference: _ctx.selectedReference,
      onClose: _ctx.closeInformationSampleModal,
      onOpenInventoryImageModal: _ctx.openInventoryImageModal,
      onBuildPrimary: _ctx.buildPrimaryReferenceTransaction,
      onDeletePrimary: _ctx.deletePrimaryReferenceTransaction,
      onDeleteSecondary: _ctx.deleteSecondaryReferenceTransaction
    }, null, 8, ["originalReference", "onClose", "onOpenInventoryImageModal", "onBuildPrimary", "onDeletePrimary", "onDeleteSecondary"]), [
      [_vShow, _ctx.modalInfoSample]
    ]),
    _withDirectives(_createVNode(_component_ModalCreateEditInventoryImage, {
      onCloseImageInventory: _ctx.closeInventoryImageModal,
      onSecondary: _ctx.buildSecondaryReferenceTransaction,
      onDeleteSecondary: _ctx.deleteSecondaryReferenceTransaction,
      additional: _ctx.selectedAdditional
    }, null, 8, ["onCloseImageInventory", "onSecondary", "onDeleteSecondary", "additional"]), [
      [_vShow, _ctx.modalInventoryImage]
    ]),
    _withDirectives(_createVNode(_component_ModalConfirmation, {
      message: _ctx.confirmMessage,
      onAccept: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeConfirmModalAsync(_ctx.deletePrimaryReferenceTransaction))),
      onDeny: _ctx.closeConfirmModalAsync
    }, null, 8, ["message", "onDeny"]), [
      [_vShow, _ctx.showConfirmModal]
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("p", null, "Muestrario", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_StandardButton, {
            buttonLabel: 'Crear referencia',
            onClick: _ctx.createNewReference
          }, null, 8, ["onClick"]),
          _createElementVNode("a", {
            href: _ctx.route,
            class: "wrapper-button"
          }, [
            _createVNode(_component_StandardButton, { buttonLabel: 'Descargar reporte de imágenes' })
          ], 8, _hoisted_4)
        ])
      ]),
      _createElementVNode("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.references, (reference, index) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "sample",
            key: index
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: reference.main,
                alt: "",
                class: "cloth-image"
              }, null, 8, _hoisted_7),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_EditButton, {
                  onClick: ($event: any) => (_ctx.editReference(reference))
                }, null, 8, ["onClick"]),
                _createVNode(_component_DeleteButton, {
                  onClick: ($event: any) => (_ctx.selectDeletedReference(reference)),
                  type: 'Delete'
                }, null, 8, ["onClick"])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("p", null, "Ref. " + _toDisplayString(reference.reference), 1),
              _createElementVNode("p", null, _toDisplayString(reference.description), 1)
            ])
          ]))
        }), 128))
      ])
    ])
  ], 64))
}